package org.hs_soft.runmynesto.domain.model.home.template.tabs.tab_general

import androidx.compose.runtime.Composable
import org.hs_soft.runmynesto.domain.util.helper.LanguageManager
import org.hs_soft.runmynesto.domain.util.helper.Strings

enum class WaiterDeviceTypeEnum(
    val listingLayouts: List<ListingLayoutsEnum>
) {
    MOBILE_WAITER(
        listingLayouts = ListingLayoutsEnum.entries
    ),
    DESKTOP_WAITER(
        listingLayouts = listOf()
    );

    @Composable
    fun getTitle(): String {
        val strings = Strings.current()
        return when (this) {
            MOBILE_WAITER -> strings.mobileWaiter
            DESKTOP_WAITER -> strings.desktopWaiter
        }
    }

    val title: String
        get() = LanguageManager.getCurrentStrings().let { strings ->
            when (this) {
                MOBILE_WAITER -> strings.mobileWaiter
                DESKTOP_WAITER -> strings.desktopWaiter
            }
        }
}